const dayNames = [
    'SUNDAY',
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
];

const monthNames = [
    "energy_page.january",
    "energy_page.february",
    "energy_page.march",
    "energy_page.april",
    "energy_page.may",
    "energy_page.june",
    "energy_page.july",
    "energy_page.august",
    "energy_page.september",
    "energy_page.october",
    "energy_page.november",
    "energy_page.december"
]

export function formatNumber(value: number, digitCount = 2): string {
    const output = value.toString();
    if (output.length < digitCount) {
        return Array(digitCount - output.length).fill(0).join('') + output;

    }
    return output;

}

export function getFormattedDayName(date: Date) {
    return dayNames[date.getDay()];
}

export function getFormattedDate(date: Date) {
    return `${formatNumber(date.getDate())}.${formatNumber(date.getMonth() + 1)}.${formatNumber(date.getFullYear())}`;
}

export function getFormattedTime(date: Date) {
    return `${formatNumber(date.getHours())}:${formatNumber(date.getMinutes())}`;
}

export function getFormattedDayNameForWebsocket(date: number) {
    return dayNames[date]
}
export function getFormattedMonthNameForWebsocket(month: number) {
    return monthNames[month]
}
